export default __webpack_public_path__ + "static/media/GuyAnimation19.8479eee1.svg";